export interface ParsedCDNFileLink {
  fileExtension: string
  url: string
}

/**
 * Parses a CDN file link (e.g. with ?extension=pdf), returning the URL without
 * query params and the extension value if present.
 */
export function parseCDNFileLink(href: string): ParsedCDNFileLink {
  const questionIndex = href.indexOf('?')
  const url = questionIndex >= 0 ? href.slice(0, questionIndex) : href
  const search = questionIndex >= 0 ? href.slice(questionIndex + 1) : ''
  const params = new URLSearchParams(search)
  const rawExtension = params.get('extension') ?? ''
  const fileExtension = rawExtension.trim().replace(/^\.+/, '').toLowerCase()
  return { fileExtension, url }
}
